import { ExtraStyle } from "../../component/Type.component";

export interface CommonLabelValue {
  label: string;
  value: string;
}

export type CommonData = {
  label: string;
};

export type Period = {
  start: number;
  end: number;
};

export type PeriodString = {
  start: string;
  end: string;
};

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export interface ICommonWrapperStyle {
  containerStyle?: ExtraStyle;
  wrapperStyle?: ExtraStyle;
}

export enum ERRORCODES {
  "AUTHENTICATION_FAILED",
}

export type IAutocompleteOptionsData<T> = {
  labelKey: keyof T;
  valueKey: keyof T;
  extraLabelKey?: keyof T;
};

export interface IBaseErrorDataResponse {
  code?: string;
  status?: number;
  timestamp?: number;
  details?: string[];
  traceId?: string;
  info?: string;
  description?: string;
}

export interface IBaseResponse<T> {
  success?: boolean;
  message: string;
  payload: T;
}

export type IBaseErrorResponse = IBaseResponse<IBaseErrorDataResponse>;

export type ICommonApiAutocompleteParams = {
  keyword?: string;
};

export type ICommonApiAutocomplete = {
  key: string;
  value: string;
};

export type ICommonApiListParams = {
  page?: number;
  size?: number;
  keyword?: string;
};

export type ICommonPageInfo = {
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
  first: boolean;
  last: boolean;
};

export type ICommonApiAutocompleteResponse<T> = IBaseResponse<T[]>;

export type ICommonApiListPayload<T> = {
  records: T[];
  pageInfo: ICommonPageInfo;
};

export type ICommonApiListResponse<T> = IBaseResponse<ICommonApiListPayload<T>>;

export interface ICommonActionLabelLoading {
  label: string;
  action: () => void;
  loading?: boolean;
}
export interface IUploadFileResponse {
  message: string;
}

export interface ICommonBanner {
  wideUrl: string;
  squareUrl: string;
}

export type ICommonTabContent = {
  children: React.ReactNode;
  active: boolean;
};
